import { createAction, props } from "@ngrx/store";
import { Item } from "src/app/models/item";
import { ItemSearchCriteria } from "src/app/models/itemSearchCriteria";

import { CartItem } from "../cartItem";

export const addToCart = createAction(
    '[Cart] Add Item',
    props<{ item: Item }>()
);

export const addOne = createAction(
    '[Cart] Add One Available Item',
    props<{ cartItem: CartItem }>()
);

export const removeOne = createAction(
    '[Cart] Remove One Available Item',
    props<{ cartItem: CartItem }>()
);

export const invertLine = createAction(
    '[Cart] Invert Line',
    props<{ cartItem: CartItem }>()
);

export const removeLine = createAction(
    '[Cart] Remove Line',
    props<{ cartItem: CartItem }>()
);

export const resetCart = createAction(
    '[Cart] Reset Cart'
);

export const getItemsByCode = createAction(
    '[Search] Get Items By Code',
    props<{ code: string }>()
);

export const getItemsByCriteria = createAction(
    '[Search] Get Items By Criteria',
    props<{ itemSearchCriteria: ItemSearchCriteria }>()
)

export const itemSearchSuccess = createAction(
    '[Search] Items Search Success',
    props<{ items: Item[] }>()
);


// TODO: CONTROL PROPS
export const itemSearchFail = createAction(
    '[Search] Items Search Fail',
    props<{ error }>()
);


export const searchFieldReset = createAction(
    '[Search] Search Field Reset'
);